import React from "react";
import "./modal.css";
import { IoCloseSharp } from "react-icons/io5";
import { useState, useEffect, useRef } from "react";
import { useAppContext } from "../../Context/AppContext.jsx";
import Select from "react-select";
import { toast } from "sonner";
import { uploadProduct } from "../Functions/uploadProduct.jsx";
import { validateProduct } from "../Functions/validateProduct.jsx";
import { uploadImage } from "../Functions/uploadImage.jsx";
import { useNavigate } from "react-router-dom";
import sleep from "../Functions/sleep.jsx";
const allowCategories = [
  "Entrantes y Aditivos",
  "Desayunos",
  "Pizzas y Espaguetis",
  "Hamburguesas y Sandwish",
  "Tacos",
  "Bebidas",
  "Cocteles",
  "Postres",
  "Infusiones-Cafe-Te",
];

const UpdateModal = ({ isOpen, changeState, toUpdate }) => {
  const { changes, setChanges, token, logout } = useAppContext();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    category: "",
    price: "",
    description: "",
    imageUrl: "",
  });
  const [errors, setErrors] = useState({
    name: "",
    category: "",
    price: "",
    description: "",
    image: "",
  });
  const [isFocused, setIsFocused] = useState({
    name: true,
    category: true,
    price: true,
    description: true,
  });
  const [image, setImage] = useState(null);
  const [tempImageUrl, setTempImageUrl] = useState("");
  const options = allowCategories.map((it) => {
    const value = {
      value: it,
      label: it,
    };
    return value;
  });

  const init = () => {
    if (toUpdate) {
      setFormData({
        name: toUpdate.name,
        category: { label: toUpdate.category, value: toUpdate.category },
        price: toUpdate.price,
        description: toUpdate.description,
        imageUrl: toUpdate.image_url,
      });
      setErrors({
        name: "",
        category: "",
        price: "",
        description: "",
        image: "",
      });
      setIsFocused({
        name: true,
        category: true,
        price: true,
        description: true,
      });
      setImage(null);
      setTempImageUrl("");
    }
  };

  const setKeyForm = (key, value) => {
    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };
  const setKeyError = (key, value) => {
    setErrors((prev) => ({
      ...prev,
      [key]: value,
    }));
  };
  const setCategory = (value) => {
    setKeyForm("category", value);
  };
  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id]: value,
    }));
  };
  const handleExit = (e) => {
    if (e) e.preventDefault();
    init();
    changeState(false);
  };
  const handleFiles = (files) => {
    setKeyForm("imageUrl", "");
    const dataFile = new FormData();
    dataFile.append("image", files);
    setImage(dataFile);
  };
  const onChangeImage = (e) => {
    try {
      const file = e.target.files[0];

      if (
        file.size > Number.parseInt(5 * 1025 * 1024) ||
        !file.type.startsWith("image")
      ) {
        throw new Error("Archivo no permitido.");
      }

      let url = URL.createObjectURL(file);
      setTempImageUrl(url);
      handleFiles(file);
    } catch (e) {
      toast.error(e.message);
    }
  };
  const validateForm = () => {
    const product = {
      name: formData.name,
      category: formData.category,
      price: Number.parseInt(formData.price),
      description: formData.description,
    };

    const validations = validateProduct({ product: product, required: 1 });
    setErrors(validations.errors);
    return validations.success;
  };
  const handleBlur = (e) => {
    validateForm();
    setIsFocused((prev) => ({
      ...prev,
      [e.target.id]: false,
    }));
  };
  const handleFocus = (e) => {
    setIsFocused((prev) => ({
      ...prev,
      [e.target.id]: true,
    }));
  };

  useEffect(() => {
    init();
  }, [toUpdate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const frontValidations = validateForm();

    if (!frontValidations) {
      toast.error(
        "No se pudo modificar el producto, revise los campos y vuelva a intentarlo.",
      );
      return;
    }

    let imageUrl = formData.imageUrl;
    if (!imageUrl) {
      const uploadImageFlag = await uploadImage({
        image,
        request: {
          url: process.env.REACT_APP_URL + "api/upload",
          method: "POST",
          message: "Archivo subido satisfactoriamente.",
          token: token,
        },
      });

      if (!uploadImageFlag.success) {
        setKeyForm("imageUrl", toUpdate.image_url);

        if (uploadImageFlag.message === "Token invalido") {
          await sleep(1000);
          toast.error("Inicie sesion para poder modificar el producto.");
          logout();
          navigate("/login");
          return;
        } else {
          toast.error(uploadImageFlag.message);
          return;
        }
      }

      imageUrl = uploadImageFlag.url;
    }

    const uploadProductFlag = await uploadProduct({
      product: {
        name: formData.name,
        price: Number.parseInt(formData.price),
        category: formData.category.value,
        description: formData.description,
        image_url: imageUrl,
      },
      request: {
        url: process.env.REACT_APP_URL + "api/menu/" + toUpdate.id,
        method: "PATCH",
        message: "Producto modificado exitosamente.",
        token: token,
      },
    });

    if (!uploadProductFlag.success) {
      if (uploadProductFlag.message === "Token invalido") {
        toast.error("Inicie sesion para poder modificar el producto.");
        await sleep(1000);
        logout();
        navigate("/login");
      } else {
        toast.error(uploadProductFlag.message);
        return;
      }
    } else {
      handleExit();
      toast.success(uploadProductFlag.message);
      setTimeout(() => {
        setChanges(changes + 1);
      }, 2000);
    }
  };

  return (
    <div
      className={
        isOpen
          ? "flex justify-center items-center fixed top-0 left-0 bg-[rgba(0,0,0,0.5)] w-[100vw] h-[100vh] z-[100]"
          : "hidden"
      }
    >
      <div className="bg-white flex flex-col justify-evenly rounded-[5px] max-w-[500px] ">
        <div className="flex justify-between items-center text-center  p-[20px] border-b-solid border-b-slate-200 border-b-[1px]">
          <h1 className="font-Roboto font-semibold text-[22px]">
            Update Product
          </h1>
          <button className="" onClick={() => handleExit()}>
            <IoCloseSharp />
          </button>
        </div>

        <form className="py-[20px] px-[50px] flex flex-col gap-[20px] min-w-[500px]">
          <div className="input-container">
            <label
              htmlFor="name"
              className="relative before:content-['*']  before:absolute before:-top-[6px] before:-left-[6px] before:text-red-400"
            >
              Name
            </label>
            <input
              type="text"
              id="name"
              value={formData.name}
              className={`peer flex focus:outline-none focus:ring-[2px] focus:ring-blue-600 bg-[var(--var-gris)] text-lg min-h-10 p-2.5 rounded-md min-w-[200px] text-sm font-sans border border-solid border-gray-300 placeholder-gray-400 ${errors.name ? "border-red-400 focus:border-none" : ""}`}
              onChange={handleChange}
              placeholder="Product Name"
              onBlur={handleBlur}
              onFocus={handleFocus}
            />
            {!isFocused.name && errors.name ? (
              <div className="peer-ring-[2px] peer-ring-red-400 text-red-400 text-sm font-thin">
                {errors.name}
              </div>
            ) : (
              ""
            )}
          </div>
          <div className="input-container">
            <label
              htmlFor="category"
              className="relative before:content-['*']  before:absolute before:-top-[6px] before:-left-[6px] before:text-red-400"
            >
              Category
            </label>

            <Select
              options={options}
              isFocused={0}
              inputId="category"
              placeholder="Product Category"
              onChange={setCategory}
              value={formData.category}
              onBlur={handleBlur}
              onFocus={handleFocus}
              styles={{
                control: (base) => ({
                  ...base,
                  backgroundColor: "var(--var-gris)",
                  display: "flex",
                  width: "100%",
                  fontSize: "14px",
                  height: "40px",
                }),
              }}
            />
            {!isFocused.category && errors.category ? (
              <div className="peer-ring-[2px] peer-ring-red-400 text-red-400 text-sm font-thin">
                {errors.category}
              </div>
            ) : (
              ""
            )}
          </div>
          <div className="input-container">
            <label
              htmlFor="price"
              className="relative before:content-['*']  before:absolute before:-top-[6px] before:-left-[6px] before:text-red-400"
            >
              Price
            </label>
            <input
              type="number"
              id="price"
              value={formData.price}
              className="normal-nums flex focus:outline-none  focus:ring-[2px] focus:ring-blue-600 bg-[var(--var-gris)] text-lg min-h-10 p-2.5 rounded-md min-w-[200px] text-sm font-sans border border-solid border-gray-300 placeholder-gray-400"
              onChange={handleChange}
              placeholder="Product Price"
              onFocus={handleFocus}
              onBlur={handleBlur}
            />
            {!isFocused.price && errors.price ? (
              <div className="peer-ring-[2px] peer-ring-red-400 text-red-400 text-sm font-thin">
                {errors.price}
              </div>
            ) : (
              ""
            )}
          </div>
          <div className="input-container">
            <label
              htmlFor="description"
              className="relative before:content-['*']  before:absolute before:-top-[6px] before:-left-[6px] before:text-red-400"
            >
              Description
            </label>
            <textarea
              rows="5"
              columns="60"
              className="flex focus:outline-none  focus:ring-[2px] focus:ring-blue-600 bg-[var(--var-gris)] text-lg min-h-10 p-2.5 rounded-md min-w-[200px] text-sm font-sans border border-solid border-gray-300"
              type="text"
              id="description"
              value={formData.description}
              onChange={handleChange}
              placeholder="Product Description"
              onFocus={handleFocus}
              onBlur={handleBlur}
            />
            {!isFocused.description && errors.description ? (
              <div className="peer-ring-[2px] peer-ring-red-400 text-red-400 text-sm font-thin">
                {errors.description}
              </div>
            ) : (
              ""
            )}
          </div>

          <div className="flex gap-[10px] w-full">
            <img
              src={
                !tempImageUrl
                  ? `${process.env.REACT_APP_S3_ENDPOINT}/${formData.imageUrl}`
                  : tempImageUrl
              }
              alt=""
              className="rounded-[5px] object-cover shadow-sm h-[100px] w-[60%]"
            />
            <input
              type="file"
              accept="image/*"
              id="image-change"
              style={{ display: "none" }}
              onChange={onChangeImage}
            />
            <label
              htmlFor="image-change"
              className="text-sky-600 font-semibold text-[10px] underline cursor-pointer"
            >
              Cambiar imagen del producto?
            </label>
          </div>

          <div className="flex items-center justify-end w-full gap-[20px] mt-5">
            <button
              type="submit"
              className="flex p-[10px] rounded-[5px] text-slate-500 bg-slate-200"
              onClick={handleExit}
            >
              {" "}
              Cancelar{" "}
            </button>
            <button
              type="submit"
              className="flex p-[10px] rounded-[5px] text-white bg-emerald-500"
              onClick={handleSubmit}
            >
              Actualizar Producto
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UpdateModal;
